import React, { FC } from 'react';

import { LocationData } from '@folx-types/routing';

import { GlobalStyles, ResetStyles } from '../GlobalStyles';

interface LayoutProps {
	children: React.ReactNode;
	location: LocationData;
}

const Layout: FC<LayoutProps> = ({ children, location }) => {
	return (
		<>
			<ResetStyles />
			{location?.pathname !== '/graphiql_v2/' && <GlobalStyles />}
			<>{children}</>
		</>
	);
};

export default Layout;
